// Focus a Bootstrap modal's [data-modal-autofocus] field when it opens.
//
// The HTML autofocus attribute can't do this: it only fires on initial
// document parse — and the browser blocks it with an "Autofocus processing
// was blocked" console warning when the document already has a focused
// element — so a field inside a closed modal never focuses when the modal is
// later shown. Marking the field with data-modal-autofocus instead defers
// focus to Bootstrap's `shown.bs.modal` (bubbled to document, so one
// delegated listener covers every modal, including ones rendered later).
// The React FormModal honors the same attribute for frame-hosted forms.
export function initModalAutofocus(doc = document) {
  const handler = (event) => {
    const modal = event.target;
    if (!(modal instanceof Element)) return;
    modal.querySelector("[data-modal-autofocus]")?.focus();
  };
  doc.addEventListener("shown.bs.modal", handler);
  return () => doc.removeEventListener("shown.bs.modal", handler);
}
